import isEmpty from 'lodash/isEmpty'
import { SET_TEAM } from '@/store/mutation-types'
import service from '@/service'
import nbsp from '@/assets/js/nbsp'

const state = {
  people: []
}

const getters = {
  team (state, getters, { i18n }) {
    const localizePerson = person => ({
      ...person,
      position: person.position[i18n.locale],
      description: person.description[i18n.locale]
    })

    return state.people.map(localizePerson)
  },
  associateTeam (state, getters) {
    return getters.team.filter(({ type }) => type === 1)
  },
  cooperationTeam (state, getters) {
    return getters.team.filter(({ type }) => type === 2)
  },
  workedTeam (state, getters) {
    return getters.team.filter(({ type }) => type === 3)
  }
}

const mutations = {
  [SET_TEAM] (state, team = []) {
    const createPerson = person => ({
      name: person.name,
      position: {
        pl: person.title,
        en: person.title_en
      },
      description: {
        pl: nbsp(person.description),
        en: nbsp(person.description_en)
      },
      type: +person.type,
      email: person.email,
      phone: person.phone,
      photo: person.imgUrl,
      column: person.column
    })

    state.people = team.map(createPerson)
  }
}

const actions = {
  fetchTeam ({ state, commit }) {
    if (!isEmpty(state.people)) return Promise.resolve()

    return service.team.people().then((res = {}) => {
      commit(SET_TEAM, res.people)
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/team.js